// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
async function __xevt_beforeEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console, Date } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console; void Date;
    
    ui.setSessionExpired(900000,logout);
}
export { __xevt_beforeEdit as beforeEdit };
async function __xevt_afterEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console, Date } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console; void Date;
    
    self.setFieldPropertyValue("BTVERSION", "title", "Versión: " + appData.getGlobalMacro("##VERSION##"));
}
export { __xevt_afterEdit as afterEdit };
async function __xevt_login(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console, Date } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console; void Date;
    
    var params = {
                        userName: self.USER,
                        password: self.PWD,
                        entryPoint: "Inicio",
                
                        // Opcional
                        onLoginSuccessful: async function() {
                             ui.showToast("Login OK!");
                        },  
                
                        // Opcional
                        onLoginFailed: async function() {
                            ui.showToast("Login failed!");
                        }
                    };
                    appData.login(params);
}
export { __xevt_login as login };
async function __xevt_onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, clipboard, Bundle, console, Date } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void clipboard; void Bundle; void console; void Date;
    
    appData.failWithMessage(-11888,"##EXITAPP##");
}
export { __xevt_onback as onback };